/**
 * 전역 토스트 – 중앙 하단 검은 배경, 은은한 스타일 (의존성 없음).
 * 서버 flash 메시지 및 클라이언트에서 전역 사용.
 */

const DURATION_MS = 3500;
const CONTAINER_ID = "dpr-toast-container";

const COLORS = {
  default: "rgba(30, 41, 59, 0.95)",
  success: "rgba(22, 101, 52, 0.95)",
  error: "rgba(127, 29, 29, 0.95)",
  warning: "rgba(120, 53, 15, 0.95)",
  info: "rgba(30, 58, 138, 0.95)",
} as const;

function getContainer(): HTMLDivElement {
  let el = document.getElementById(CONTAINER_ID) as HTMLDivElement | null;
  if (!el) {
    el = document.createElement("div");
    el.id = CONTAINER_ID;
    el.style.cssText = [
      "position:fixed",
      "left:0",
      "right:0",
      "bottom:24px",
      "display:flex",
      "flex-direction:column",
      "align-items:center",
      "gap:8px",
      "pointer-events:none",
      "z-index:9999",
    ].join(";");
    document.body.appendChild(el);
  }
  return el;
}

function show(message: string, type: keyof typeof COLORS = "default"): void {
  const container = getContainer();
  const toast = document.createElement("div");
  toast.style.cssText = [
    "background:" + COLORS[type],
    "color:#f1f5f9",
    "padding:12px 20px",
    "border-radius:8px",
    "font-size:14px",
    "line-height:1.4",
    "max-width:90vw",
    "box-shadow:0 4px 20px rgba(0,0,0,0.25)",
    "animation:dpr-toast-in 0.25s ease",
  ].join(";");
  toast.textContent = message;

  ensureToastStyles();
  container.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = "0";
    toast.style.transition = "opacity 0.2s ease";
    setTimeout(() => toast.remove(), 200);
  }, DURATION_MS);
}

let stylesInjected = false;
function ensureToastStyles(): void {
  if (stylesInjected) return;
  stylesInjected = true;
  const style = document.createElement("style");
  style.textContent = `
    @keyframes dpr-toast-in {
      from { opacity: 0; transform: translateY(12px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
  document.head.appendChild(style);
}

export const Toast = {
  success(message: string): void {
    show(message, "success");
  },
  error(message: string): void {
    show(message, "error");
  },
  warning(message: string): void {
    show(message, "warning");
  },
  info(message: string): void {
    show(message, "info");
  },
  /** 기본(neutral) – 검은 배경 */
  show(message: string): void {
    show(message, "default");
  },
};

declare global {
  interface Window {
    __FLASH_MESSAGES__?: {
      success?: string | null;
      error?: string | null;
      warning?: string | null;
      info?: string | null;
      errors?: unknown;
      reset_token?: unknown;
    };
  }
}

/** 페이지 로드 시 서버에서 넘긴 flash를 토스트로 표시 (admin 레이아웃 등에서 호출) */
export function showFlashToasts(): void {
  const flash = window.__FLASH_MESSAGES__;
  if (!flash) return;
  if (flash.success) Toast.success(flash.success);
  if (flash.error) Toast.error(flash.error);
  if (flash.warning) Toast.warning(flash.warning);
  if (flash.info) Toast.info(flash.info);
  window.__FLASH_MESSAGES__ = undefined;
}
